import { detectPlatform, PLATFORMS } from 'constants/platform';
import { removeUserCredential } from 'lib/cookies';

const PLATFORM_TOKENS = {
  [PLATFORMS.VIRTUAL_PRO]: 'virtualpro',
  [PLATFORMS.WEBINAR_PLUS]: 'webinarplus',
};

// Replaces the platform token in the current hostname to build the target domain.
// Works across all environments automatically:
//   admin.virtualpro-staging.com  →  admin.webinarplus-staging.com
//   admin.virtualpro.com          →  admin.webinarplus.com
function buildTargetHostname(targetPlatform) {
  const { hostname } = window.location;
  const currentToken = PLATFORM_TOKENS[detectPlatform()];
  const targetToken = PLATFORM_TOKENS[targetPlatform];

  if (!currentToken || !targetToken || currentToken === targetToken) return null;
  if (!hostname.includes(currentToken)) return null;
  return hostname.replace(currentToken, targetToken);
}

// Pure decision function — no side effects, easy to unit test.
// Returns the target platform string if a redirect is needed, otherwise null.
export function shouldRedirectPlatform(userInfo) {
  const currentPlatform = detectPlatform();

  if (userInfo?.is_webinar_plus_enabled === undefined) return null;

  const isWebinarPlusAccount = Boolean(userInfo.is_webinar_plus_enabled);

  console.log("🚀 ~ shouldRedirectPlatform ~ isWebinarPlusAccount:", isWebinarPlusAccount)

  if (currentPlatform === PLATFORMS.VIRTUAL_PRO && isWebinarPlusAccount) {
    return PLATFORMS.WEBINAR_PLUS;
  }
  if (currentPlatform === PLATFORMS.WEBINAR_PLUS && !isWebinarPlusAccount) {
    return PLATFORMS.VIRTUAL_PRO;
  }
  return null;
}

// Redirects to the correct platform based on the admin panel is_webinar_plus_enabled flag.
// Clears the local session before navigating to prevent cross-platform session mixing.
// Returns true if a redirect was triggered, false otherwise.
// Pass authToken to carry the session token to the target platform via /tokenlogin.
export function redirectToPlatform(userInfo, authToken) {
  if (!userInfo) return false;

  const targetPlatform = shouldRedirectPlatform(userInfo);
  if (!targetPlatform) return false;

  const targetHostname = buildTargetHostname(targetPlatform);
  if (!targetHostname) return false;

  // Clear local session so credentials from one platform cannot leak to the other.
  removeUserCredential();

  const { protocol } = window.location;
  const url = new URL(`${protocol}//${targetHostname}`);
  if (authToken) {
    url.hash = `/login?token=${encodeURIComponent(authToken)}`;
  }
  // replace() avoids adding a back-button entry to the wrong-platform page
  window.location.replace(url.toString());
  return true;
}
